import { Component, Inject } from '@angular/core';
import { cdkOverlayRef } from 'src/app/shared/custom-overlay/cdk-overlay-ref';
import { WidgetBuilderVarService } from '../widget-builder-service/widget-builder-var.service';
import { SharedService } from 'src/app/services/shared.service';
import { FILE_PREVIEW_DIALOG_DATA } from 'src/app/shared/custom-overlay/cdk-overlay-injector';

interface ChartRequirements {
  minDimensions: number;
  maxDimensions: number;
  minMetrics: number;
  maxMetrics: number;
  supportsTimeSeries?: boolean;
}

interface ChartOption {
  display: string;
  value: string;
  icon: string;
  requirements: ChartRequirements;
  enable:boolean;
}

interface ChartCategory {
  display: string;
  value: string;
  options: ChartOption[];
}


@Component({
  selector: 'app-chart-type-selector',
  templateUrl: './chart-type-selector.component.html',
  styleUrls: ['./chart-type-selector.component.scss'],
  
})



export class ChartTypeSelectorComponent {

  constructor(

    private overLayRef: cdkOverlayRef,
    public widgetbuildervarservice: WidgetBuilderVarService,
    public sharedservice : SharedService,
    @Inject(FILE_PREVIEW_DIALOG_DATA) public mode: any

  ) { }
  selectedOption

  selected:string
data = [{"display" : "BASIC", "value" : "basic", "options" : [{"display" : "Line Chart", "value" : "line_chart", "icon" : "/assets/widgets/line_chart.svg", "requirements" : {"minDimensions":1,"maxDimensions":1,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":2,"maxW":4,"minH":1,"maxH":2}, "enable" : true}, {"display" : "Bar Chart", "value" : "bar_chart", "icon" : "/assets/widgets/bar_chart.svg", "requirements" : {"minDimensions":1,"maxDimensions":1,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":2,"maxW":4,"minH":1,"maxH":2}, "enable" : true}, {"display" : "Area Chart", "value" : "area_chart", "icon" : "/assets/widgets/area_chart.svg", "requirements" : {"minDimensions":1,"maxDimensions":1,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":2,"maxW":4,"minH":1,"maxH":2}, "enable" : true}, {"display" : "Pie", "value" : "pie", "icon" : "/assets/widgets/pie.svg", "requirements" : {"minDimensions":1,"maxDimensions":1,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":2,"maxW":4,"minH":1,"maxH":2}, "enable" : true}, {"display" : "Dounut", "value" : "dounut", "icon" : "/assets/widgets/dounut.svg", "requirements" : {"minDimensions":1,"maxDimensions":1,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":2,"maxW":4,"minH":1,"maxH":2}, "enable" : true}]}, {"display" : "STACKED", "value" : "stacked", "options" : [{"display" : "Line Stack", "value" : "line_stack", "icon" : "/assets/widgets/line_stack.svg", "requirements" : {"minDimensions":2,"maxDimensions":2,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":2,"maxW":4,"minH":1,"maxH":2}, "enable" : true}, {"display" : "Bar Stack", "value" : "bar_stack", "icon" : "/assets/widgets/bar_stack.svg", "requirements" : {"minDimensions":2,"maxDimensions":2,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":2,"maxW":4,"minH":1,"maxH":2}, "enable" : true}, {"display" : "Area Stack", "value" : "area_stack", "icon" : "/assets/widgets/area_stack.svg", "requirements" : {"minDimensions":2,"maxDimensions":2,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":2,"maxW":4,"minH":1,"maxH":2}, "enable" : true}]}, {"display" : "HEATMAP", "value" : "heatmap", "options" : [{"display" : "Heatmap", "value" : "heatmap", "icon" : "/assets/widgets/heatmap.svg", "requirements" : {"minDimensions":2,"maxDimensions":2,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":4,"maxW":12,"minH":2,"maxH":6}, "enable" : true}, {"display" : "Polar Heatmap", "value" : "polar_heatmap", "icon" : "/assets/widgets/polar_heatmap.svg", "requirements" : {"minDimensions":2,"maxDimensions":2,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":4,"maxW":6,"minH":4,"maxH":6}, "enable" : true}]}, {"display" : "POLAR BAR", "value" : "polar_bar", "options" : [{"display" : "Polar Tangential Bar", "value" : "polar_tangential_bar", "icon" : "/assets/widgets/polar_tangential_bar.svg", "requirements" : {"minDimensions":2,"maxDimensions":2,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":4,"maxW":6,"minH":4,"maxH":6}, "enable" : true}, {"display" : "Polar Radial Bar", "value" : "polar_radial_bar", "icon" : "/assets/widgets/polar_radial_bar.svg", "requirements" : {"minDimensions":2,"maxDimensions":2,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":4,"maxW":6,"minH":4,"maxH":6}, "enable" : true}]}, {"display" : "GUAGE", "value" : "guage", "options" : [{"display" : "Guard Guage", "value" : "guard_guage", "icon" : "/assets/widgets/guard_guage.svg", "requirements" : {"minDimensions":1,"maxDimensions":1,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":4,"maxW":6,"minH":4,"maxH":6}, "enable" : true}]}, {"display" : "FLOW", "value" : "flow", "options" : [{"display" : "Sankey", "value" : "sankey", "icon" : "/assets/widgets/sankey.svg", "requirements" : {"minDimensions":3,"maxDimensions":4,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":4,"maxW":6,"minH":4,"maxH":6}, "enable" : true}, {"display" : "Treemap", "value" : "treemap", "icon" : "/assets/widgets/treemap.svg", "requirements" : {"minDimensions":3,"maxDimensions":4,"minMetrics":1,"maxMetrics":1}, "size" : {"minW":4,"maxW":6,"minH":4,"maxH":6}, "enable" : true}]}]
  // data: ChartCategory[] = [
  //   {
  //     display: 'BASIC',
  //     value: 'basic',
  //     options: [
  //       {
  //         display: 'Line Chart',
  //         value: 'line',
  //         icon: '/assets/widgets/line_chart.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 2,
  //           minMetrics: 1,
  //           maxMetrics: 10,
  //           supportsTimeSeries: true
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Bar Chart',
  //         value: 'bar',
  //         icon: '/assets/widgets/bar_chart.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 2,
  //           minMetrics: 1,
  //           maxMetrics: 10
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Area Chart',
  //         value: 'area',
  //         icon: '/assets/widgets/area_chart.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 2,
  //           minMetrics: 1,
  //           maxMetrics: 10,
  //           supportsTimeSeries: true
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Pie',
  //         value: 'pie',
  //         icon: '/assets/widgets/pie_chart.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 1,
  //           minMetrics: 1,
  //           maxMetrics: 1
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Donut',
  //         value: 'donut',
  //         icon: '/assets/widgets/donut_chart.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 1,
  //           minMetrics: 1,
  //           maxMetrics: 1
  //         },
  //         enable:true
  //       }
  //     ]
  //   },
  //   {
  //     display: 'STACKED',
  //     value: 'stacked',
  //     options: [
  //       {
  //         display: 'Linestack',
  //         value: 'line_stack',
  //         icon: '/assets/widgets/line_stack.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 2,
  //           minMetrics: 2,
  //           maxMetrics: 10
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Bar Stack',
  //         value: 'bar_stack',
  //         icon: '/assets/widgets/bar_stack.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 2,
  //           minMetrics: 2,
  //           maxMetrics: 10
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Area Stack',
  //         value: 'area_stack',
  //         icon: '/assets/widgets/area_stack.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 2,
  //           minMetrics: 2,
  //           maxMetrics: 10
  //         },
  //         enable:true
  //       }
  //     ]
  //   },
  //   {
  //     display: 'HEATMAP',
  //     value: 'heatmap',
  //     options: [
  //       {
  //         display: 'Heatmap',
  //         value: 'heatmap',
  //         icon: '/assets/widgets/heatmap.svg',
  //         requirements: {
  //           minDimensions: 2,
  //           maxDimensions: 2,
  //           minMetrics: 1,
  //           maxMetrics: 1
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Polar Heat',
  //         value: 'polar_heat',
  //         icon: '/assets/widgets/polar_heat.svg',
  //         requirements: {
  //           minDimensions: 2,
  //           maxDimensions: 2,
  //           minMetrics: 1,
  //           maxMetrics: 1
  //         },
  //         enable:true
  //       }
  //     ]
  //   },
  //   {
  //     display: 'POLAR',
  //     value: 'polar',
  //     options: [
  //       {
  //         display: 'Polar Tangential Bar',
  //         value: 'polar_tangential_bar',
  //         icon: '/assets/widgets/polar_tangential.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 2,
  //           minMetrics: 1,
  //           maxMetrics: 2
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Polar Radial Bar',
  //         value: 'polar_radial_bar',
  //         icon: '/assets/widgets/polar_radial.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 2,
  //           minMetrics: 1,
  //           maxMetrics: 2
  //         },
  //         enable:true
  //       }
  //     ]
  //   },
  //   {
  //     display: 'GAUGE',
  //     value: 'gauge',
  //     options: [
  //       {
  //         display: 'Gauge Bar',
  //         value: 'gauge_bar',
  //         icon: '/assets/widgets/gauge.svg',
  //         requirements: {
  //           minDimensions: 0,
  //           maxDimensions: 1,
  //           minMetrics: 1,
  //           maxMetrics: 1
  //         },
  //         enable:true
  //       }
  //     ]
  //   },
  //   {
  //     display: 'FLOW',
  //     value: 'flow',
  //     options: [
  //       {
  //         display: 'Sankey',
  //         value: 'sankey',
  //         icon: '/assets/widgets/sankey.svg',
  //         requirements: {
  //           minDimensions: 2,
  //           maxDimensions: 3,
  //           minMetrics: 1,
  //           maxMetrics: 1
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Treemap',
  //         value: 'treemap',
  //         icon: '/assets/widgets/treemap.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 3,
  //           minMetrics: 1,
  //           maxMetrics: 1
  //         },
  //         enable:true
  //       }
  //     ]
  //   },
  //   {
  //     display: 'OTHERS',
  //     value: 'others',
  //     options: [
  //       {
  //         display: 'Label',
  //         value: 'label',
  //         icon: '/assets/widgets/label.svg',
  //         requirements: {
  //           minDimensions: 0,
  //           maxDimensions: 0,
  //           minMetrics: 1,
  //           maxMetrics: 1
  //         },
  //         enable:true
  //       },
  //       {
  //         display: 'Table',
  //         value: 'table',
  //         icon: '/assets/widgets/table.svg',
  //         requirements: {
  //           minDimensions: 1,
  //           maxDimensions: 5,
  //           minMetrics: 1,
  //           maxMetrics: 5
  //         },
  //         enable:true
  //       }
  //     ]
  //   }
  // ];
  

  ngOnInit(){

//console.log("Input =---->",this.mode)

//console.log("Chart selected type =---->",this.widgetbuildervarservice.selectedChart)

    // if(this.widgetbuildervarservice.chartType){
    //   this.selectedOption = this.widgetbuildervarservice.chartType
    // }

    if(this.widgetbuildervarservice.selectedChart){
      this.selectedOption = this.widgetbuildervarservice.selectedChart
    }

    
    if(this.widgetbuildervarservice.dataSetFields.no_of_dimensions != null && this.widgetbuildervarservice.dataSetFields.no_of_metrics != null){
      this.changeChartState()
    }

        if(this.mode === "preview"){

          if(!['pie', 'donut','guard_guage', 'sankey','polar_heatmap', 'polar_tangential_bar', 'polar_radial_bar', 'treemap', 'nightingale'].includes(this.widgetbuildervarservice.selectorChart)){
            this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
              val.options.forEach(chart=>{
                if(!this.widgetbuildervarservice.styleValidation.axes.includes(chart.value) || chart.value == 'heatmap'){
                  chart.enable=false
                }
                if(this.widgetbuildervarservice.selectorChart == chart.value){
                    chart.enable=true
                }
                if(this.widgetbuildervarservice.selectorChart == 'heatmap'){
                  if(chart.value == 'polar_heatmap'){
                    chart.enable=true
                  }
                }
              })
            })
          }else{
            this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
              val.options.forEach(chart=>{
                if(chart.value == 'polar_heatmap' || chart.value == 'heatmap' || chart.value == 'sankey'){
                  chart.enable=false
                }
                if(this.widgetbuildervarservice.selectorChart == chart.value){
                    chart.enable=true
                }
                if(this.widgetbuildervarservice.selectorChart == 'polar_heatmap'){
                  if(chart.value == 'heatmap' || chart.value == 'polar_heatmap'){
                    chart.enable = true
                  }
                  else{
                    chart.enable = false
                  }
                }
              
              })
            })
          }
          if(this.widgetbuildervarservice.selectorChart =='guard_guage'){
            this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
              val.options.forEach(chart=>{
                if(chart.value != 'guard_guage'){
                  chart.enable=false
                }
              })
            })
          }
          if(this.widgetbuildervarservice.selectorChart =='area_stack'){
            this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
              val.options.forEach(chart=>{
                if(chart.value == 'horizontal_bar' || chart.value == 'line_chart' || chart.value == 'area_chart' || chart.value == 'bar_chart'){
                  chart.enable=false
                }
              })
            })
          }
          if(this.widgetbuildervarservice.selectorChart =='line_chart' || this.widgetbuildervarservice.selectorChart =='area_chart' || this.widgetbuildervarservice.selectorChart =='bar_chart'  ){
            this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
              val.options.forEach(chart=>{
                if(chart.value == 'line_stack' || chart.value == 'area_stack' || chart.value == 'bar_stack'){
                  chart.enable=false
                }
              })
            })
          }

          this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
            val.options.forEach(chart=>{
              if(chart.value === "label" || chart.value === "table"){
                chart.enable=false
              }
            })
          })
        }

        // if(this.mode === "preview"){
        //   let minD 
        //   let maxD
        //   let minM
        //   let maxM
        //   console.log("Selector chart ->",this.widgetbuildervarservice.selectorChart)
        //   this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
        //     val.options.forEach(chart=>{
        //       // console.log(chart)
              
        //       if(chart.value == this.widgetbuildervarservice.selectorChart){
        //         minD = chart.requirements.minDimensions
        //         maxD = chart.requirements.maxDimensions
        //         minM = chart.requirements.minMetrics
        //         maxM = chart.requirements.maxMetrics
        //       }
             
        //     })
        //   })
        //   this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
        //     val.options.forEach(chart=>{
        //       // console.log(chart.requirements.maxDimensions,this.widgetbuildervarservice.setupForm.get('setup').get('dimensions').get('fields').value.length)
        //       if(chart.requirements.minDimensions >= minD && chart.requirements.minDimensions<= maxD && chart.requirements.maxDimensions == this.widgetbuildervarservice.setupForm.get('setup').get('dimensions').get('fields').value.length){
        //         chart.enable = true
        //       }else{
        //         chart.enable = false
        //       }
        //       if(chart.value == 'label' || chart.value == 'table' ){
        //         chart.enable = false
        //       }
        //     })
        //   })

        // }
  }



  changeChartState(){
//console.log("Change chart Type")
    this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
      val.options.forEach(chart=>{
        if(this.widgetbuildervarservice.dataSetFields.no_of_dimensions >= chart.requirements.minDimensions){
          chart.enable=true
        }else{
          chart.enable=false
        }
      })
    })
  }

  onOptionSelect(option: ChartOption): void {
//console.log(option);
    this.selectedOption = option
    if(this.mode === "selector"){
      if( this.widgetbuildervarservice.selectorChart != option.value){
      
// console.log("selectedOption",this.selectedOption)
      if(this.selectedOption){
//console.log("Clear array")

          // this.widgetbuildervarservice.ListOfCharts.forEach(val=>{
          //   val.options.forEach(chart=>{
          //     // console.log(chart)
          //     if(chart.value == this.selectedOption.value){
          //       console.log(chart.requirements.minDimensions)
          //       console.log(this.widgetbuildervarservice.setupForm.get('setup').get('dimensions').get('fields').value.length)
          //       console.log(chart.requirements.maxDimensions)
          //       if(this.widgetbuildervarservice.setupForm.get('setup').get('dimensions').get('fields').value.length >= chart.requirements.minDimensions && this.widgetbuildervarservice.setupForm.get('setup').get('dimensions').get('fields').value.length == chart.requirements.maxDimensions){
          //         console.log("Keep values")
          //       }else{
          //         console.log("Clear values")
          //         this.widgetbuildervarservice.resetSetupForm()
          //       }
          //     }
             
          //   })
          // })


          this.widgetbuildervarservice.resetSetupForm()
      }
    }
      
    }
    if(this.mode === "selector"){
      if( this.widgetbuildervarservice.selectorChart != option.value){
        this.widgetbuildervarservice.selectorChart=option.value
      this.widgetbuildervarservice.styleStruct=this.applyStyleValidation(this.selectedOption.value,this.widgetbuildervarservice.styleValidation,this.widgetbuildervarservice.styleStruct)
      this.widgetbuildervarservice.setupFormValue=this.applySetupValidation(this.selectedOption.value,this.widgetbuildervarservice.setupValidation,this.widgetbuildervarservice.setupFormValue)

//console.log("Setup =---->",this.widgetbuildervarservice.setupFormValue)
//console.log("On Selector")
      this.widgetbuildervarservice.selectedChart=this.selectedOption
//console.log("Chart selector 1 =---->",this.widgetbuildervarservice.chartType)
      this.widgetbuildervarservice.chartType = this.selectedOption.value
      this.widgetbuildervarservice.refreshChart('reset')
      
      let name = "Untitled_Chart_"
      let time = this.sharedservice.getcurrentuserTime().format('DDMMYYYYHHmmss')

      name += time
      if(!this.widgetbuildervarservice.widgetEditMode){
        this.widgetbuildervarservice.setupForm.get('setup').get('widget_name').setValue(name)
        this.widgetbuildervarservice.styleForm.get('widget_title').setValue("Chart title")
      }else{
        this.widgetbuildervarservice.setupForm.get('setup').get('widget_name').setValue(this.widgetbuildervarservice.editValue.setup.widget_name)
        this.widgetbuildervarservice.styleForm.get('widget_title').setValue(this.widgetbuildervarservice.editValue.style.widget_title)
      }

      }
      
    }

   
      if(this.selectedOption && this.mode === "preview"){
        this.overLayRef._cube.next(this.selectedOption)
      }
    // if(this.mode === "selector"){
      this.overLayRef.close()
    // }
   
  }

  applyStyleValidation(chartType, styleValidation: any, styleStruct: any) {
    const updatedStruct = { ...styleStruct };
  
    Object.keys(updatedStruct).forEach((key) => {
      const allowedCharts = styleValidation[key] || [];
      const isAllowed = allowedCharts.includes(chartType);
  
      
      updatedStruct[key].accordian_state = isAllowed ? false : false;
      updatedStruct[key].disable = !isAllowed;
    });

//console.log({updatedStruct})
  
    return updatedStruct;
  }

  applySetupValidation(chartType, styleValidation: any, styleStruct: any) {
    const updatedStruct = { ...styleStruct };
  
    Object.keys(updatedStruct.setup).forEach((key) => {
      if(key != "widget_name" && key != "chart-type"){
        const allowedCharts = styleValidation[key] || [];
        const isAllowed = allowedCharts.includes(chartType);

//console.log(key , "--->", isAllowed)
    
        
        updatedStruct.setup[key].accordianState = (chartType != 'label' && chartType!= 'guard_guage') &&  key === 'dimensions' ? true : false;
        updatedStruct.setup[key].disable = !isAllowed;

        if(chartType == 'label' || chartType == 'guard_guage'){
          updatedStruct.setup["metrics"].accordianState = true
        }
      }
    });

//console.log({updatedStruct})
  
    return updatedStruct;
  }

  ngOnDestroy(){
    // if(this.selectedOption && this.mode === "preview"){
    //   this.overLayRef._cube.next(this.selectedOption)
    // }
    // if(this.mode === "selector"){
    //   this.widgetbuildervarservice.styleStruct=this.applyStyleValidation(this.selectedOption.value,this.widgetbuildervarservice.styleValidation,this.widgetbuildervarservice.styleStruct)
    //   this.widgetbuildervarservice.setupFormValue=this.applySetupValidation(this.selectedOption.value,this.widgetbuildervarservice.setupValidation,this.widgetbuildervarservice.setupFormValue)

    //   console.log("Setup =---->",this.widgetbuildervarservice.setupFormValue)
    //   this.widgetbuildervarservice.selectedChart=this.selectedOption
    //   this.widgetbuildervarservice.chartType = this.selectedOption.value
    //   this.widgetbuildervarservice.refreshChart('reset')
    // }
  }
}